export default [
  {
    path: '/eventlist/list',
    name: 'alleventlist',
    meta: {
      title: '全部事件单'
    },
    component: () => import (/* webpackChunkName: "example-eventlist" */ '../views/eventlist/list.vue')
  },
  {
    path: '/eventlist/details',
    name: 'details',
    meta: {
      title: '事件单详情'
    },
    component: () => import (/* webpackChunkName: "example-eventlist" */ '../views/eventlist/details.vue')
  },
  {
    path: '/eventlist/allList',
    name: 'allList',
    meta: {
      title: '事件线索池'
    },
    component: () => import (/* webpackChunkName: "example-eventlist" */ '../views/eventlist/allList.vue')
  }
]
